export interface IWsCorreo {
    IdCorreos: number;
    IdSolucion: number;
    Solucion: string;
    Responsable: string;
    Seguimiento: string;
    Central: string;
    CC: string;
    IdLineaNegocio: number;
    LineaNegocio: string;
}

export class WsCorreo {
    IdCorreos: number;
    IdSolucion: number;
    Solucion: string;
    Responsable: string;
    Seguimiento: string;
    Central: string;
    CC: string;
    IdLineaNegocio: number;
    LineaNegocio: string;

    constructor(data?: IWsCorreo) {
        if (data) {
            this.IdCorreos = data.IdCorreos;
            this.IdSolucion = data.IdSolucion;
            this.Solucion = data.Solucion;
            this.Responsable = data.Responsable;
            this.Seguimiento = data.Seguimiento;
            this.Central = data.Central;
            this.CC = data.CC;
            this.IdLineaNegocio = data.IdLineaNegocio;
            this.LineaNegocio = data.LineaNegocio;
        }
    }
}
